/**
 * Created by Ning Jiang on 11/22/2016.
 */

///<reference path="../../node_modules/@nolimitcity/slot-game/lib/gsap/src/CustomEase.d.ts"/>
require("@nolimitcity/slot-game/lib/gsap/src/umd/CustomEase.js");
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {DungeonQuestSymbolTransformView} from "./bigSymbols/DungeonQuestSymbolTransformView";
import {DungeonQuestShockWaveController} from "./winPresentations/DungeonQuestShockWaveController";
import {Background} from "@nolimitcity/slot-game/bin/core/background/Background";
import {ColorEffectTextureCache} from "../utils/ColorEffectTextureCache";
import {DungeonQuestLogoAreaView} from "./backgrounds/DungeonQuestLogoAreaView";
import {WinCountUpDisplay} from "./winPresentations/WinCountUpDisplay";
import {DungeonQuestRandomTransformController} from "./features/randomTransform/DungeonQuestRandomTransformController";
import {DungeonQuestRandomColossalWildController} from "./features/randomColossalWild/DungeonQuestRandomColossalWildController";
import {SoundPlayer} from "./soundplayer/SoundPlayer";
import {DungeonQuestReelAreaEffectController} from "./backgrounds/DungeonQuestReelAreaEffectController";
import {DungeonQuestFreeSpinFeatureController} from "./features/freespin/DungeonQuestFreeSpinFeatureController";

export class DungeonQuest extends SlotGame {
    public static background:Background;
    public static symbolTransformView:DungeonQuestSymbolTransformView;
    public static shockWaveController:DungeonQuestShockWaveController;
    public static colorEffectTextureCache:ColorEffectTextureCache;
    public static logoAreaView:DungeonQuestLogoAreaView;
    public static winCountUpDisplay:WinCountUpDisplay;
    public static soundPlayer:SoundPlayer;
    public static randomTransform:DungeonQuestRandomTransformController;
    public static randomColossalWild:DungeonQuestRandomColossalWildController;
    public static reelAreaEffectController:DungeonQuestReelAreaEffectController;
    public static freeSpinFeatureController:DungeonQuestFreeSpinFeatureController;


    getNoWinGameData():any {
        return {
            "reels": [
                [
                    "M3",
                    "M3",
                    "M3",
                    "L3",
                    "L3",
                    "L3",
                    "L3",
                    "L4",
                    "L4",
                    "L4",
                    "L4",
                    "L2",
                    "L2"
                ],
                [
                    "M2",
                    "M2",
                    "M2",
                    "M2",
                    "L1",
                    "L1",
                    "L1",
                    "L1",
                    "M3",
                    "M3",
                    "M3",
                    "M3",
                    "L3"
                ],
                [
                    "M4",
                    "M4",
                    "M4",
                    "L3",
                    "L3",
                    "L3",
                    "L3",
                    "M2",
                    "M2",
                    "M2",
                    "M2",
                    "L1",
                    "L1"
                ],
                [
                    "M2",
                    "M2",
                    "M2",
                    "M2",
                    "L3",
                    "L3",
                    "L3",
                    "L3",
                    "M1",
                    "M1",
                    "M1",
                    "M1",
                    "L2"
                ],
                [
                    "S",
                    "M1",
                    "M1",
                    "M1",
                    "M1",
                    "L2",
                    "L2",
                    "L2",
                    "L2",
                    "L3",
                    "L3",
                    "L3",
                    "L3"
                ]
            ],
            "overlayReels": [
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ]
            ],
            "totalSpinWinnings": 0,
            "betLineWins": [],
            "accumulatedRoundWin": 0,
            "playedBetValue": 0.6,
            "freespinsRemaining": 0,
            "freespinsPlayed": 0,
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "previousReels": [
                [
                    "M3",
                    "M3",
                    "M3",
                    "L3",
                    "L3",
                    "L3",
                    "L3",
                    "L4",
                    "L4",
                    "L4",
                    "L4",
                    "L2",
                    "L2"
                ],
                [
                    "M2",
                    "M2",
                    "M2",
                    "M2",
                    "L1",
                    "L1",
                    "L1",
                    "L1",
                    "M3",
                    "M3",
                    "M3",
                    "M3",
                    "L3"
                ],
                [
                    "M4",
                    "M4",
                    "M4",
                    "L3",
                    "L3",
                    "L3",
                    "L3",
                    "M2",
                    "M2",
                    "M2",
                    "M2",
                    "L1",
                    "L1"
                ],
                [
                    "M2",
                    "M2",
                    "M2",
                    "M2",
                    "L3",
                    "L3",
                    "L3",
                    "L3",
                    "M1",
                    "M1",
                    "M1",
                    "M1",
                    "L2"
                ],
                [
                    "S",
                    "M1",
                    "M1",
                    "M1",
                    "M1",
                    "L2",
                    "L2",
                    "L2",
                    "L2",
                    "L3",
                    "L3",
                    "L3",
                    "L3"
                ]
            ],
            "freespinTriggered": false,
            "reelsNextSpin": "BASE_REELSET",
            "bigSymbolInfoList": [],
            "symbolTransformTriggered": false,
            "symbolToWildTriggered": false,
            "symbolToBeTransformed": "",
            "overlaySymbolsBeforeSpin": [
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ]
            ],
            "overlaySymbolsAfterSpin": [
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ]
            ],
            "nearWinReels": [
                false,
                false,
                false,
                false,
                false
            ],
            "scatterPositions": [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "freespinPlayed": 0,
            "reelsForHistory": [
                [
                    "L3",
                    "L3",
                    "L3",
                    "L3",
                    "L4",
                    "L4",
                    "L4"
                ],
                [
                    "M2",
                    "L1",
                    "L1",
                    "L1",
                    "L1",
                    "M3",
                    "M3"
                ],
                [
                    "L3",
                    "L3",
                    "L3",
                    "L3",
                    "M2",
                    "M2",
                    "M2"
                ],
                [
                    "M2",
                    "L3",
                    "L3",
                    "L3",
                    "L3",
                    "M1",
                    "M1"
                ],
                [
                    "M1",
                    "M1",
                    "L2",
                    "L2",
                    "L2",
                    "L2",
                    "L3"
                ]
            ]
        };
    }
}